// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3bUrw","modalFooterButton":"ModalNotes_modalFooterButton__1-uZR"};